var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4947 17.2985L19.9121 7.7034C19.9647 7.63524 19.9949 7.55605 19.9994 7.47427C20.0039 7.39249 19.9827 7.31117 19.9379 7.23899C19.893 7.16681 19.8264 7.10646 19.7449 7.06438C19.6635 7.02229 19.5703 7.00004 19.4754 7L4.64062 7C4.54568 7.00004 4.45253 7.02229 4.37109 7.06438C4.28966 7.10646 4.22298 7.16681 4.17817 7.23899C4.13336 7.31117 4.11209 7.39249 4.11662 7.47427C4.12116 7.55605 4.15133 7.63524 4.20393 7.7034L11.6213 17.2985C11.6693 17.3605 11.7342 17.4113 11.8104 17.4465C11.8865 17.4816 11.9716 17.5 12.058 17.5C12.1444 17.5 12.2295 17.4816 12.3057 17.4465C12.3818 17.4113 12.4468 17.3605 12.4947 17.2985Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownFill);
export default __webpack_public_path__ + "static/media/icon-down-fill.0c1fd17a7a9b275fec5a9af551bf1d19.svg";
export { ForwardRef as ReactComponent };